import { useState } from 'react';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import translator from '@Components/Utilities/Translator';
import { loadable } from '@Components/Utilities/SandhillsLoadable';

const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

const AccessibilityStatement = (props) => {

    const detectClick = (e) => {
        if (e.target.className == "AccessibilityFeedback") {
            toggleFeedbackModal();
            e.preventDefault();
        }
    };

    const [showFeedbackModal, setShowFeedbackModal] = useState(props.ShowFeedbackModalOnLoad);
    const toggleFeedbackModal = () => setShowFeedbackModal(showFeedbackModal => !showFeedbackModal);

    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            </div>
            <div className='accessibility-statement-container'>
                <span onClick={detectClick} dangerouslySetInnerHTML={{ __html: props.HtmlMarkup }} />
            </div>
            {showFeedbackModal &&
                <FeedbackModal
                    {...props}
                    toggleModal={toggleFeedbackModal}
                    title={translator.translate('sandhills.tradepubwebsite.mvc.feedbackemail')}
                />}
        </div>
    );
};

export default AccessibilityStatement;
global.AccessibilityStatement = AccessibilityStatement;